import {
  altImageDefault,
  descriptionDefault,
  keywordsDefault,
  titleDefault,
  urlImageDefault
} from "./metaData.constants";
import {
  getMetaDescriptionFixed,
  getMetaTitleFixed,
  makeItemMetaDataDefault, makeItemMetaDataOpenGraph, makeItemMetaDataTwitter
} from "./metaData.helpers";

/**
 * Not use it directly in the React!
 * Use only to create another method makeMetaData[NAME]!
 * @param {MetaData} holderMetaData
 * @param {string} title
 * @param {string} description
 * @param {string[]|string}keywords
 * @returns {MetaData}
 * @private
 */
export const _makeMetaDataHTMLCommon = (holderMetaData, title, description, keywords) => {
  holderMetaData.push(
    makeItemMetaDataDefault("title", getMetaTitleFixed(title || titleDefault)),
    makeItemMetaDataDefault(
      "description", getMetaDescriptionFixed(description || descriptionDefault)
    ),
  );

  if (Array.isArray(keywords)) {
    holderMetaData.push(
      makeItemMetaDataDefault("keywords", keywords.length ? keywords.join(", ") : keywordsDefault)
    );
  } else {
    holderMetaData.push(
      makeItemMetaDataDefault("keywords", keywords || keywordsDefault)
    );
  }

  return holderMetaData;
};

/**
 * Not use it directly in the React!
 * Use only to create another method makeMetaData[NAME]!
 * @param {MetaData} holderMetaData
 * @param {string} title
 * @param {string} description
 * @param {string} urlPage
 * @param {string?} urlImage
 * @param {string?} imageAlt
 * @returns {MetaData}
 * @private
 */
export const _makeMetaDataOpenGraphCommon = (
  holderMetaData,
  title, description,
  urlPage,
  urlImage, imageAlt,
) => {
  holderMetaData.push(
    makeItemMetaDataOpenGraph("type", "website"),
    makeItemMetaDataOpenGraph("title", getMetaTitleFixed(title || titleDefault)),
    makeItemMetaDataOpenGraph(
      "description", getMetaDescriptionFixed(description || descriptionDefault)
    ),
    makeItemMetaDataOpenGraph("url", urlPage),
  
    makeItemMetaDataOpenGraph("image", urlImage || urlImageDefault),
    makeItemMetaDataOpenGraph("image:alt", imageAlt || altImageDefault),
  );
  return holderMetaData;
};

/**
 * Not use it directly in the React!
 * Use only to create another method makeMetaData[NAME]!
 * @param {MetaData} holderMetaData
 * @param {string} title
 * @param {string} description
 * @param {string?} imageUrl
 * @param {string?} imageAlt
 * @param {string?} twitterUsername
 * @returns {MetaData}
 * @private
 */
export const _makeMetaDataTwitterCommon = (
  holderMetaData,
  title, description,
  imageUrl, imageAlt,
  twitterUsername,
) => {
  holderMetaData.push(
    makeItemMetaDataTwitter("card", "summary"),
    makeItemMetaDataTwitter("title", getMetaTitleFixed(title) || titleDefault),
    makeItemMetaDataTwitter(
      "description", getMetaDescriptionFixed(description) || descriptionDefault
    ),
    makeItemMetaDataTwitter("image", imageUrl || urlImageDefault),
    makeItemMetaDataTwitter("image:alt", imageAlt || altImageDefault),
  );

  // @username for the website used in the card footer.
  if (twitterUsername) {
    holderMetaData.push(
      makeItemMetaDataTwitter("site", twitterUsername),
    );
  }

  return holderMetaData;
};

/**
 * Use this method to generate metadata of any common page.
 * @param objHolderMetaData
 * @param {string} title
 * @param {string} description
 * @param {string[]|string} keywords
 * @param {string} urlPage
 * @param {string?} imageUrl
 * @param {string?} imageAlt
 * @param {string?} twitterUsername
 */
export const makeMetaDataCommon = (
  objHolderMetaData,
  title, description, keywords,
  urlPage,
  imageUrl, imageAlt,
  twitterUsername
) => {
  _makeMetaDataHTMLCommon(objHolderMetaData, title, description, keywords);
  _makeMetaDataOpenGraphCommon(objHolderMetaData, title, description, urlPage, imageUrl, imageAlt);
  _makeMetaDataTwitterCommon(
    objHolderMetaData, title, description, imageUrl, imageAlt, twitterUsername
  );

  return objHolderMetaData;
};

